// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"8ab446a7","160":"0e8e32bd","208":"5b39a8c0","293":"f8d7768c","488":"519f2d08","516":"e7c72059","519":"63100533","732":"8815ff56","917":"3c4d086b","946":"eea63502","977":"bdc9ed84"}[chunkId] + ".chunk.js";
};